<div class="bg-[#fdfbff] dark:bg-surface-0 min-h-full transition-colors duration-300 flex flex-col">
  <!-- Header Section -->
  <div
    class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 sticky top-0 z-20 bg-[#fdfbff] dark:bg-surface-0 px-6 py-5 border-b border-gray-100 dark:border-slate-800">
    <h1 class="text-xl font-bold text-[#141437] dark:text-white">Detail Admin Performance View</h1>

    <div class="flex items-center flex-wrap md:flex-nowrap gap-3 ml-auto mr-4">
      @if(adminList.length > 1) {
      <div class="w-64">
        <app-dropdown [disabled]="isLoading()" [options]="adminList" [selectedValue]="adminId().toString()"
          (selectionChange)="onAdminChange($event)" placeholder="Select Administrator" variant="default" size="md">
        </app-dropdown>
      </div>
      }
      <app-date-picker [showComparison]="false" [showGroupBy]="true" [value]="datePickerValue()"
        [allowedGroupByUnits]="['day','week','month','quarter','year']" (dateRangeChange)="onDateRangeChange($event)">
      </app-date-picker>
    </div>

    <button (click)="closePanel.emit()"
      class="flex p-2 -mr-2 text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-full transition-colors cursor-pointer shrink-0">
      <app-icon-v2 name="x" [size]="24" customClass="text-gray-500 dark:text-gray-400"></app-icon-v2>
    </button>
  </div>

  <div class="p-6">
    <!-- Profile Card -->
    @if (isLoading()) {
    <div
      class="bg-white dark:bg-surface-2 rounded-[2rem] p-8 flex items-center gap-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] dark:shadow-none mb-8 border border-transparent dark:border-gray-700 animate-pulse">
      <div class="w-20 h-20 bg-slate-200 dark:bg-slate-700/50 rounded-[1.25rem] shrink-0"></div>
      <div class="flex-grow">
        <div class="h-8 w-48 bg-slate-200 dark:bg-slate-700/60 rounded mb-3"></div>
        <div class="h-4 w-64 bg-slate-200 dark:bg-slate-700/40 rounded"></div>
      </div>
      <div class="flex gap-12 mr-8">
        <div class="flex flex-col gap-2">
          <div class="h-3 w-24 bg-slate-200 dark:bg-slate-700/40 rounded"></div>
          <div class="h-7 w-16 bg-slate-200 dark:bg-slate-700/60 rounded"></div>
        </div>
        <div class="flex flex-col gap-2">
          <div class="h-3 w-24 bg-slate-200 dark:bg-slate-700/40 rounded"></div>
          <div class="h-7 w-16 bg-slate-200 dark:bg-slate-700/60 rounded"></div>
        </div>
        <div class="flex flex-col gap-2">
          <div class="h-3 w-24 bg-slate-200 dark:bg-slate-700/40 rounded"></div>
          <div class="h-7 w-16 bg-slate-200 dark:bg-slate-700/60 rounded"></div>
        </div>
        <div class="flex flex-col gap-2">
          <div class="h-3 w-24 bg-slate-200 dark:bg-slate-700/40 rounded"></div>
          <div class="h-7 w-16 bg-slate-200 dark:bg-slate-700/60 rounded"></div>
        </div>
      </div>
    </div>
    } @else {
    <div
      class="bg-white dark:bg-surface-2 rounded-[2rem] p-8 flex items-center gap-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] dark:shadow-none mb-8 border border-transparent dark:border-gray-700">
      <div
        class="w-20 h-20 bg-[#f3f4f6] dark:bg-surface-0/50 rounded-[1.25rem] flex items-center justify-center text-[1.75rem] font-semibold text-[#374151] dark:text-gray-200">
        {{ adminInfo().initials }}
      </div>
      <div class="flex-grow">
        <h2 class="text-3xl font-bold text-[#141437] dark:text-white">{{ adminInfo().name }}</h2>
        <div class="flex items-center gap-2 text-gray-500 dark:text-gray-400 mt-1">
          <app-icon-v2 name="User" size="16"></app-icon-v2>
          <span>ID: {{ adminInfo().id }}</span>
          <span>•</span>
          <span>{{ adminInfo().role }}</span>
        </div>
      </div>
      <div class="flex gap-12 mr-8">
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#6b7280] dark:text-gray-400 font-medium">Total Arrangements</span>
          <span class="text-2xl font-bold text-[#111827] dark:text-white">{{ adminInfo().totalArrangements }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#6b7280] dark:text-gray-400 font-medium">Success Rate %</span>
          <span class="text-2xl font-bold text-[#111827] dark:text-white">{{ adminInfo().successRate }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#6b7280] dark:text-gray-400 font-medium">Unique Contracts</span>
          <span class="text-2xl font-bold text-[#111827] dark:text-white">{{ adminInfo().uniqueContracts }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#6b7280] dark:text-gray-400 font-medium">Performance Score</span>
          <span class="text-2xl font-bold text-[#111827] dark:text-white">{{ adminInfo().performanceScore }}</span>
        </div>
      </div>
    </div>
    }

    <!-- KPI Cards Row -->
    <div class="grid grid-cols-5 gap-4">
      @if (isLoading()) {
      @for (i of [1,2,3,4,5]; track i) {
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-4 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 animate-pulse flex items-start gap-3 h-[88px]">
        <div class="w-11 h-11 rounded-[14px] bg-slate-200 dark:bg-slate-700/50 shrink-0"></div>
        <div class="flex flex-col flex-1 justify-between h-full py-0.5">
          <div class="h-3 w-20 bg-slate-200 dark:bg-slate-700/40 rounded"></div>
          <div class="flex justify-between items-end">
            <div class="h-6 w-16 bg-slate-200 dark:bg-slate-700/60 rounded"></div>
            <div class="h-3 w-8 bg-slate-200 dark:bg-slate-700/40 rounded"></div>
          </div>
        </div>
      </div>
      }
      } @else {
      @for (kpi of kpis; track kpi.label) {
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-4 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 relative transition-all duration-300 hover:-translate-y-1 hover:shadow-lg dark:hover:shadow-none h-full">
        <div class="flex items-stretch gap-3 h-full">
          <!-- First Column: Icon -->
          <div class="w-11 h-11 rounded-[14px] flex items-center justify-center text-white shrink-0 my-auto"
            [ngClass]="[kpi.iconBg, kpi.shadowClass]">
            <app-icon-v2 [name]="kpi.icon" size="20"></app-icon-v2>
          </div>

          <!-- Second Column: Label and Value/Trend -->
          <div class="flex flex-col flex-1 justify-between min-w-0 py-0.5">
            <span
              class="text-[11px] xl:text-xs min-[1600px]:text-sm text-[#6b7280] dark:text-gray-400 font-medium leading-tight mb-1 truncate">{{
              kpi.label }}</span>
            <div class="flex justify-between items-end gap-0.5 min-[1600px]:gap-1 flex-wrap lg:flex-nowrap w-full">
              <span
                class="text-base lg:text-lg min-[1500px]:text-xl min-[1600px]:text-[30px] font-bold text-[#141437] dark:text-white leading-none truncate max-w-full">{{
                kpi.value }}</span>
              <div class="flex items-center gap-0.5 min-[1600px]:gap-1 shrink-0 mb-0.5 min-w-max" *ngIf="kpi.trend">
                @if(kpi.trendIcon){
                <app-icon-v2 [name]="kpi.trendIcon" size="14" [customClass]="kpi.colorClass"></app-icon-v2>
                }
                <span class="text-[10px] xl:text-[11px] min-[1600px]:text-[13px] font-bold leading-none"
                  [ngClass]="kpi.colorClass">{{ kpi.trend }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      }
    </div>

    <!-- Charts Row -->
    <div class="grid grid-cols-2 gap-4 mt-6">
      <!-- Operational Funnel Analysis -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700">
        <div class="mb-6">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Operational Funnel Analysis</h3>
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400">Operational Funnel from Creation to Execution</p>
        </div>
        <div class="relative flex flex-col items-center justify-center overflow-visible min-h-[280px]">
          @if (isLoading()) {
          <app-individual-toaster fontSize="20px"
            class="absolute inset-0 z-10 flex items-center justify-center rounded-xl"></app-individual-toaster>
          }
          @if (totalCreated() > 0) {
          <app-pie-chart [data]="funnelData()" mode="semi" type="slices" [addGradient]="true" [numSlices]="15"
            [showLegend]="true" legendPosition="bottom" [showLegendValues]="false" [legendTextColored]="false"
            [centerValue]="$safeNavigationMigration(funnelData()[0]?.value)" [currentTheme]="currentTheme()" [width]="450" [height]="300">
          </app-pie-chart>
          } @else if (!isLoading()) {
          <div
            class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500 bg-slate-50/30 dark:bg-surface-0/20 rounded-xl backdrop-blur-[1px] border border-slate-100/50 dark:border-gray-800/30 transition-all duration-500 z-10">
            <div class="relative mb-4 group">
              <div
                class="absolute inset-0 bg-blue-400 dark:bg-blue-600 blur-2xl opacity-10 group-hover:opacity-20 transition-opacity rounded-full">
              </div>
              <app-icon-v2 name="database" [size]="56"
                class="relative opacity-30 dark:opacity-20 group-hover:scale-110 transition-transform duration-500"></app-icon-v2>
            </div>
            <p class="text-base font-bold text-slate-600 dark:text-slate-300 tracking-tight">No Data Available</p>
            <p class="text-xs mt-1.5 text-slate-400 dark:text-slate-500 max-w-[200px] text-center leading-relaxed">
              We couldn't find any records for the selected parameters.
            </p>
          </div>
          }
        </div>
      </div>

      <!-- Execution Performance Over Time -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700">
        <div class="mb-6">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Execution Performance Over Time</h3>
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400">Volume Growth and Conversion Efficiency</p>
        </div>
        <div class="relative h-[280px]">
          @if (isLoading()) {
          <app-individual-toaster fontSize="20px"
            class="absolute inset-0 z-10 flex items-center justify-center rounded-xl"></app-individual-toaster>
          }
          @if (performanceStats().length > 0) {
          <app-bar-line [data1]="performanceStats()" valueKey="total_created" labelKey="unit_date" valueType=""
            barLabel="Total Created" [colors]="{data1: '#0C66E8'}"
            [lines]="[{key: 'success_rate', label: 'Success %', color: '#10b981', axis: 'right'}]" [tooltipData]="[
            {label: 'Total Created', key: 'total_created', type: 'count'},
            {label: 'Success %', key: 'success_rate', type: 'percent'}
          ]" [showBackground]="false" [showXGrid]="true" [maxBarWidth]="40" [barTextposition]="'none'"
            [formatDateXAxis]="false" [margin]="{top: 20, right: 30, bottom: 50, left: 50}"
            [currentTheme]="currentTheme()" [height]="300">
          </app-bar-line>
          } @else if (!isLoading()) {
          <div
            class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500 bg-slate-50/30 dark:bg-surface-0/20 rounded-xl backdrop-blur-[1px] border border-slate-100/50 dark:border-gray-800/30 transition-all duration-500 z-10 mt-6">
            <div class="relative mb-4 group">
              <div
                class="absolute inset-0 bg-blue-400 dark:bg-blue-600 blur-2xl opacity-10 group-hover:opacity-20 transition-opacity rounded-full">
              </div>
              <app-icon-v2 name="database" [size]="56"
                class="relative opacity-30 dark:opacity-20 group-hover:scale-110 transition-transform duration-500"></app-icon-v2>
            </div>
            <p class="text-base font-bold text-slate-600 dark:text-slate-300 tracking-tight">No Data Available</p>
            <p class="text-xs mt-1.5 text-slate-400 dark:text-slate-500 max-w-[200px] text-center leading-relaxed">
              We couldn't find any records for the selected parameters.
            </p>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Second Charts Row: Contract Completion + Execution Gap -->
    <div class="grid grid-cols-2 gap-4 mt-4">

      <!-- Contract Completion Status -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 overflow-visible">
        <div class="mb-4">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Contract Completion Status</h3>
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400">Distribution of Completed, Active and Overdue
            Contracts
          </p>
        </div>
        <div class="relative min-h-[360px] flex items-center justify-center overflow-visible pb-6 px-4">
          @if (isLoading()) {
          <app-individual-toaster fontSize="20px"
            class="absolute inset-0 z-10 flex items-center justify-center rounded-xl"></app-individual-toaster>
          }
          @if (contractStatusData().length > 0 && contractStatusTotal > 0) {
          <app-pie-chart [data]="contractStatusData()" type="default" [showLegend]="true" legendPosition="right"
            [showLegendValues]="true" [legendTextColored]="true" [showLabelsOnHover]="false" [showPolylines]="true"
            [addGradient]="true" [is3d]="true" [width]="360" [height]="360" [currentTheme]="currentTheme()"
            [hideZeroValues]="true" [pieScale]="0.55" [labelReachScale]="0.85" [fitToContainer]="true">
          </app-pie-chart>
          } @else if (!isLoading()) {
          <div
            class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500 bg-slate-50/30 dark:bg-surface-0/20 rounded-xl backdrop-blur-[1px] border border-slate-100/50 dark:border-gray-800/30 transition-all duration-500 z-10">
            <div class="relative mb-4 group">
              <div
                class="absolute inset-0 bg-blue-400 dark:bg-blue-600 blur-2xl opacity-10 group-hover:opacity-20 transition-opacity rounded-full">
              </div>
              <app-icon-v2 name="database" [size]="56"
                class="relative opacity-30 dark:opacity-20 group-hover:scale-110 transition-transform duration-500"></app-icon-v2>
            </div>
            <p class="text-base font-bold text-slate-600 dark:text-slate-300 tracking-tight">No Data Available</p>
            <p class="text-xs mt-1.5 text-slate-400 dark:text-slate-500 max-w-[200px] text-center leading-relaxed">
              We couldn't find any records for the selected parameters.
            </p>
          </div>
          }
        </div>
      </div>

      <!-- Execution Gap Profile -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700">
        <div class="mb-4">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Execution Gap Profile</h3>
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400">Distribution of Execution Delays by Time Bucket</p>
        </div>
        <div class="relative h-[280px] flex items-center gap-4 w-full">
          @if (isLoading()) {
          <app-individual-toaster fontSize="20px"
            class="absolute inset-0 z-10 flex items-center justify-center rounded-xl"></app-individual-toaster>
          }
          <!-- Polar area chart: always mounted so ResizeObserver captures dimensions -->
          <div class="flex-1">
            <app-polar-area-chart [data]="executionGapData()" scaleType="logarithmic" [currentTheme]="currentTheme()"
              [margin]="{ top: 20, right: 20, bottom: 0, left: 20 }">
            </app-polar-area-chart>
          </div>
          <!-- Custom legend -->
          <div class="flex flex-col gap-3 shrink-0 pr-2">
            @for (item of executionGapData(); track item.label) {
            <div class="flex items-center gap-2">
              <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background-color]="item.color"></span>
              <span class="text-[13px] text-[#374151] dark:text-gray-300 font-medium">{{ item.label }}</span>
            </div>
            }
          </div>
          <!-- No-data overlay (only shown when no data; chart stays mounted beneath) -->
          @if (!hasExecutionGapData && !isLoading()) {
          <div
            class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500 bg-slate-50/30 dark:bg-surface-0/20 rounded-xl backdrop-blur-[1px] border border-slate-100/50 dark:border-gray-800/30 transition-all duration-500 z-10">
            <div class="relative mb-4 group">
              <div
                class="absolute inset-0 bg-blue-400 dark:bg-blue-600 blur-2xl opacity-10 group-hover:opacity-20 transition-opacity rounded-full">
              </div>
              <app-icon-v2 name="database" [size]="56"
                class="relative opacity-30 dark:opacity-20 group-hover:scale-110 transition-transform duration-500"></app-icon-v2>
            </div>
            <p class="text-base font-bold text-slate-600 dark:text-slate-300 tracking-tight">No Data Available</p>
            <p class="text-xs mt-1.5 text-slate-400 dark:text-slate-500 max-w-[200px] text-center leading-relaxed">
              We couldn't find any records for the selected parameters.
            </p>
          </div>
          }
        </div>
      </div>

    </div>

    <!-- Success and Failed Arrangements Row -->
    <div class="grid grid-cols-2 gap-4 mt-4">

      <!-- Success Arrangements -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 relative overflow-hidden">
        @if (isLoading()) {
        <app-individual-toaster fontSize="20px"
          class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
        }
        <div class="flex justify-between items-start mb-6">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Success Arrangements</h3>
          <div class="flex items-center gap-1 px-2.5 py-1 rounded text-xs font-semibold"
            *ngIf="successArrangements().trend !== null"
            [ngClass]="successArrangements().trend > 0 ? 'bg-green-50 dark:bg-[#15B268]/10 text-[#15B268]' : (successArrangements().trend < 0 ? 'bg-red-50 dark:bg-[#F05050]/10 text-[#F05050]' : 'bg-gray-100 dark:bg-gray-800 text-gray-500')">
            <app-icon-v2
              [name]="successArrangements().trend > 0 ? 'TrendingUp' : (successArrangements().trend < 0 ? 'TrendingDown' : 'Minus')"
              size="12"></app-icon-v2>
            <span>{{ successArrangements().trend > 0 ? '+' : '' }}{{ successArrangements().trend }}%</span>
          </div>
        </div>

        <div class="flex items-center justify-between">
          <div>
            <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-1">Total Recovered</p>
            <p class="text-[28px] font-bold text-[#141437] dark:text-white">${{ successArrangements().totalRecovered |
              number:'1.2-2' }}</p>
          </div>

          <div class="flex items-center gap-6">
            <div class="border-l-[3px] pl-4"
              [ngClass]="successArrangements().recurring === 0 ? 'border-[#e5e7eb] dark:border-gray-700' : 'border-[#15B268]'">
              <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-1">Recurring</p>
              <p class="text-xl font-bold"
                [ngClass]="successArrangements().recurring === 0 ? 'text-[#9ca3af]' : 'text-[#15B268]'">{{
                successArrangements().recurring }}</p>
            </div>
            <div class="border-l-[3px] pl-4"
              [ngClass]="successArrangements().partial === 0 ? 'border-[#e5e7eb] dark:border-gray-700' : 'border-[#15B268]'">
              <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-1">Partial</p>
              <p class="text-xl font-bold"
                [ngClass]="successArrangements().partial === 0 ? 'text-[#9ca3af]' : 'text-[#15B268]'">{{
                successArrangements().partial }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Failed Arrangements -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 relative overflow-hidden">
        @if (isLoading()) {
        <app-individual-toaster fontSize="20px"
          class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
        }
        <div class="flex justify-between items-start mb-6">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Failed Arrangements</h3>
          <div class="flex items-center gap-1 px-2.5 py-1 rounded text-xs font-semibold"
            *ngIf="failedArrangements().trend !== null"
            [ngClass]="failedArrangements().trend > 0 ? 'bg-red-50 dark:bg-[#F05050]/10 text-[#F05050]' : (failedArrangements().trend < 0 ? 'bg-green-50 dark:bg-[#15B268]/10 text-[#15B268]' : 'bg-gray-100 dark:bg-gray-800 text-gray-500')">
            <app-icon-v2
              [name]="failedArrangements().trend > 0 ? 'TrendingUp' : (failedArrangements().trend < 0 ? 'TrendingDown' : 'Minus')"
              size="12"></app-icon-v2>
            <span>{{ failedArrangements().trend > 0 ? '+' : '' }}{{ failedArrangements().trend }}%</span>
          </div>
        </div>

        <div class="flex items-center justify-between">
          <div>
            <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-1">Loss Amount</p>
            <p class="text-[28px] font-bold text-[#141437] dark:text-white">${{ failedArrangements().lossAmount |
              number:'1.2-2' }}</p>
          </div>

          <div class="flex items-center gap-6">
            <div class="border-l-[3px] pl-4"
              [ngClass]="failedArrangements().recurring === 0 ? 'border-[#e5e7eb] dark:border-gray-700' : 'border-[#F05050]'">
              <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-1">Recurring</p>
              <p class="text-xl font-bold"
                [ngClass]="failedArrangements().recurring === 0 ? 'text-[#9ca3af]' : 'text-[#F05050]'">{{
                failedArrangements().recurring }}</p>
            </div>
            <div class="border-l-[3px] pl-4"
              [ngClass]="failedArrangements().partial === 0 ? 'border-[#e5e7eb] dark:border-gray-700' : 'border-[#F05050]'">
              <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-1">Partial</p>
              <p class="text-xl font-bold"
                [ngClass]="failedArrangements().partial === 0 ? 'text-[#9ca3af]' : 'text-[#F05050]'">{{
                failedArrangements().partial }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Financial Performance Overview -->
    <div
      class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 mt-4 relative overflow-hidden">
      @if(isLoading()) {
      <app-individual-toaster fontSize="20px"
        class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
      }
      <div class="mb-6">
        <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Financial Performance Overview</h3>
        <p class="text-[13px] text-[#6b7280] dark:text-gray-400">Scheduled vs Recovered Value and Efficiency Metrics</p>
      </div>

      <div class="grid grid-cols-5 gap-4">
        <div class="border border-[#e5e7eb] dark:border-gray-700 rounded-xl p-4">
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-2">Scheduled Value</p>
          <p class="text-[1.35rem] font-bold text-[#141437] dark:text-white mb-2 leading-tight">${{
            financialMetrics().scheduledValue | number:'1.2-2' }}</p>
          <div class="flex items-center gap-1 text-[11px] text-[#6b7280] dark:text-gray-400">
            <app-icon-v2
              [name]="financialMetrics().scheduledTrend > 0 ? 'TrendingUp' : (financialMetrics().scheduledTrend < 0 ? 'TrendingDown' : 'Minus')"
              size="12"
              [customClass]="financialMetrics().scheduledTrend > 0 ? 'text-[#10b981]' : (financialMetrics().scheduledTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"></app-icon-v2>
            <span
              [ngClass]="financialMetrics().scheduledTrend > 0 ? 'text-[#10b981]' : (financialMetrics().scheduledTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"
              class="font-semibold">{{ financialMetrics().scheduledTrend > 0 ? '+' : '' }}{{
              financialMetrics().scheduledTrend }}%</span> vs prev period
          </div>
        </div>

        <div class="border border-[#e5e7eb] dark:border-gray-700 rounded-xl p-4">
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-2">Recovered Value</p>
          <p class="text-[1.35rem] font-bold text-[#141437] dark:text-white mb-2 leading-tight">${{
            financialMetrics().recoveredValue | number:'1.2-2' }}</p>
          <div class="flex items-center gap-1 text-[11px] text-[#6b7280] dark:text-gray-400">
            <app-icon-v2
              [name]="financialMetrics().recoveredTrend > 0 ? 'TrendingUp' : (financialMetrics().recoveredTrend < 0 ? 'TrendingDown' : 'Minus')"
              size="12"
              [customClass]="financialMetrics().recoveredTrend > 0 ? 'text-[#10b981]' : (financialMetrics().recoveredTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"></app-icon-v2>
            <span
              [ngClass]="financialMetrics().recoveredTrend > 0 ? 'text-[#10b981]' : (financialMetrics().recoveredTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"
              class="font-semibold">{{ financialMetrics().recoveredTrend > 0 ? '+' : '' }}{{
              financialMetrics().recoveredTrend }}%</span> vs prev period
          </div>
        </div>

        <div class="border border-[#e5e7eb] dark:border-gray-700 rounded-xl p-4">
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-2">Recovery Rate</p>
          <p class="text-[1.35rem] font-bold text-[#141437] dark:text-white mb-2 leading-tight">{{
            financialMetrics().recoveryRate | number:'1.1-1' }}%</p>
          <div class="flex items-center gap-1 text-[11px] text-[#6b7280] dark:text-gray-400">
            <app-icon-v2
              [name]="financialMetrics().recoveryRateTrend > 0 ? 'TrendingUp' : (financialMetrics().recoveryRateTrend < 0 ? 'TrendingDown' : 'Minus')"
              size="12"
              [customClass]="financialMetrics().recoveryRateTrend > 0 ? 'text-[#10b981]' : (financialMetrics().recoveryRateTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"></app-icon-v2>
            <span
              [ngClass]="financialMetrics().recoveryRateTrend > 0 ? 'text-[#10b981]' : (financialMetrics().recoveryRateTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"
              class="font-semibold">{{ financialMetrics().recoveryRateTrend > 0 ? '+' : '' }}{{
              financialMetrics().recoveryRateTrend }}%</span> vs prev period
          </div>
        </div>

        <div class="border border-[#e5e7eb] dark:border-gray-700 rounded-xl p-4">
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-2">Per Success</p>
          <p class="text-[1.35rem] font-bold text-[#141437] dark:text-white mb-2 leading-tight">${{
            financialMetrics().perSuccess | number:'1.2-2' }}</p>
          <div class="flex items-center gap-1 text-[11px] text-[#6b7280] dark:text-gray-400">
            <app-icon-v2
              [name]="financialMetrics().perSuccessTrend > 0 ? 'TrendingUp' : (financialMetrics().perSuccessTrend < 0 ? 'TrendingDown' : 'Minus')"
              size="12"
              [customClass]="financialMetrics().perSuccessTrend > 0 ? 'text-[#10b981]' : (financialMetrics().perSuccessTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"></app-icon-v2>
            <span
              [ngClass]="financialMetrics().perSuccessTrend > 0 ? 'text-[#10b981]' : (financialMetrics().perSuccessTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"
              class="font-semibold">{{ financialMetrics().perSuccessTrend > 0 ? '+' : '' }}{{
              financialMetrics().perSuccessTrend }}%</span> vs prev period
          </div>
        </div>

        <div class="border border-[#e5e7eb] dark:border-gray-700 rounded-xl p-4">
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400 mb-2">Average Value</p>
          <p class="text-[1.35rem] font-bold text-[#141437] dark:text-white mb-2 leading-tight">${{
            financialMetrics().averageValue | number:'1.2-2' }}</p>
          <div class="flex items-center gap-1 text-[11px] text-[#6b7280] dark:text-gray-400">
            <app-icon-v2
              [name]="financialMetrics().averageValueTrend > 0 ? 'TrendingUp' : (financialMetrics().averageValueTrend < 0 ? 'TrendingDown' : 'Minus')"
              size="12"
              [customClass]="financialMetrics().averageValueTrend > 0 ? 'text-[#10b981]' : (financialMetrics().averageValueTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"></app-icon-v2>
            <span
              [ngClass]="financialMetrics().averageValueTrend > 0 ? 'text-[#10b981]' : (financialMetrics().averageValueTrend < 0 ? 'text-[#ef4444]' : 'text-gray-400')"
              class="font-semibold">{{ financialMetrics().averageValueTrend > 0 ? '+' : '' }}{{
              financialMetrics().averageValueTrend }}%</span> vs prev period
          </div>
        </div>
      </div>
    </div>

    <!-- Third Row: Timeline and Isometric Bar Charts -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
      <div
        class="bg-white dark:bg-surface-1 rounded-xl p-4 sm:p-5 shadow-sm border border-[#e5e7eb] dark:border-gray-800 relative overflow-hidden">
        @if (isLoading()) {
        <app-individual-toaster fontSize="20px"
          class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
        }
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white capitalize mb-1">Arrangement Execution Timeline
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 font-medium pb-2 mb-4">
          Creation to Execution Duration Distribution
        </p>
        <div class="w-full mt-4">
          <app-cylinder-chart class="block w-full h-full" [data]="timelineData()" [width]="500" [height]="280"
            [animate]="true" [barWidth]="30">
          </app-cylinder-chart>
        </div>
      </div>

      <div
        class="bg-white dark:bg-surface-1 rounded-xl p-4 sm:p-5 shadow-sm border border-[#e5e7eb] dark:border-gray-800 relative overflow-hidden">
        @if (isLoading()) {
        <app-individual-toaster fontSize="20px"
          class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
        }
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white capitalize mb-1">Admin Success by Arrangement
          Value
        </h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 font-medium pb-2 mb-4">
          Execution performance segmented by contract amount
        </p>
        <div class="w-full mt-4">
          <app-isometric-bar class="block w-full h-full" [data]="successByValueData()" [width]="500" [height]="280"
            [barWidth]="35" [barDepth]="20" [angle]="30" [showGrid]="true" [showLegend]="false">
          </app-isometric-bar>
        </div>
      </div>
    </div>

    <!-- Fourth Row: Data Quality Risk & Performance Trend -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
      <!-- Data Quality Risk Overview -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 relative overflow-hidden">
        @if (isLoading()) {
        <app-individual-toaster fontSize="20px"
          class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
        }
        <div class="mb-6">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Data Quality Risk Overview</h3>
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400">Duplicate Records, Null Entries and Cleanup Progress
          </p>
        </div>
        <div class="relative h-[250px] w-full mt-2">
          <app-horizontal-bar-chart [data]="dataQualityRiskData()" [barHeight]="45" [leftMargin]="80"
            [showXAxisGrid]="true" [showYAxisGrid]="false" [showYAxisLine]="true" [showBarsValue]="true"
            [currentTheme]="currentTheme()" [marginBottom]="20" [marginTop]="10">
          </app-horizontal-bar-chart>
        </div>
      </div>

      <!-- Performance Trend by Year -->
      <div
        class="bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 relative overflow-hidden">
        @if (isLoading()) {
        <app-individual-toaster fontSize="20px"
          class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
        }
        <div class="mb-4">
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">{{ performanceTrendTitle() }}</h3>
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400">{{ performanceTrendSubtitle() }}
          </p>
        </div>
        <div class="relative h-[250px] flex items-center justify-center w-full">
          <ng-container *ngIf="hasPerformanceTrendData(); else noTrendData">
            <app-donut-chart [data]="performanceTrendData()" variant="concentric" [arcAngle]="270" [width]="320"
              [height]="250" [radiusScale]="0.9" [innerRadiusRatio]="0.4" [outerRadiusRatio]="1.0" [gapRatio]="0.2"
              [roundedCaps]="true" [showLegend]="true" [showLegendValue]="false" legendPosition="bottom"
              legendShape="circle" [maxRingWidth]="15">
            </app-donut-chart>

            <!-- Center Text for Gauge -->
            <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none pt-[20px]">
              <span class="text-[12px] font-bold text-[#141437] dark:text-white leading-tight text-center"
                [innerHTML]="performanceTrendTitle().replace(' ', '<br />')"></span>

              <div
                class="relative top-[1.5rem] flex justify-between w-[100px] mt-6 text-[#6b7280] dark:text-gray-400 text-xs font-medium">
                <span>0%</span>
                <span>100%</span>
              </div>
            </div>
          </ng-container>
          <ng-template #noTrendData>
            <div
              class="w-full flex flex-col items-center justify-center mt-8 text-center text-slate-400 dark:text-slate-500">
              <div class="relative mb-4 group opacity-50">
                <div
                  class="absolute inset-0 bg-blue-400 dark:bg-blue-600 blur-2xl opacity-10 group-hover:opacity-20 transition-opacity rounded-full">
                </div>
                <app-icon-v2 name="database" [size]="56"
                  class="relative opacity-30 dark:opacity-20 group-hover:scale-110 transition-transform duration-500"></app-icon-v2>
              </div>
              <p class="text-base font-bold text-slate-600 dark:text-slate-300 tracking-tight">No Data Available</p>
              <p class="text-xs mt-1.5 text-slate-400 dark:text-slate-500 max-w-[200px] leading-relaxed">
                We couldn't find any records for the selected parameters.
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Fifth Row: Admin Performance Scorecard -->
    <div
      class="mt-4 bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 relative overflow-hidden">
      @if(isLoading()) {
      <app-individual-toaster fontSize="20px"
        class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
      }
      <div class="mb-4">
        <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Admin Performance Scorecard</h3>
        <p class="text-[13px] text-[#6b7280] dark:text-gray-400">Comprehensive Operational, Financial & Quality Metrics
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        @for (category of scorecardCategories(); track category.title) {
        <div class="bg-gray-50/50 dark:bg-surface-1/50 rounded-xl p-5 border border-gray-100 dark:border-gray-800">
          <h4 class="text-sm font-semibold text-gray-900 dark:text-white mb-4">{{ category.title }}</h4>
          <div class="space-y-3 text-[13px]">
            @for (metric of category.metrics; track metric.label) {
            <div class="flex justify-between items-center text-gray-500 dark:text-gray-400">
              <span>{{ metric.label }}</span>
              <span [ngClass]="metric.valueColor">{{ metric.value }}</span>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>

    <!-- Sixth Row: Contract Issues & Recommendations -->
    <div
      class="mt-4 bg-white dark:bg-surface-2 rounded-[1.25rem] p-6 shadow-[0_4px_12px_rgba(0,0,0,0.03)] dark:shadow-none border border-[#efefef] dark:border-gray-700 relative overflow-hidden">
      @if(isLoading()) {
      <app-individual-toaster fontSize="20px"
        class="absolute inset-0 z-10 flex items-center justify-center"></app-individual-toaster>
      }
      <div class="mb-6 flex items-center gap-2">
        <app-icon-v2 name="Lightbulb" size="20" class="text-amber-500"></app-icon-v2>
        <div>
          <h3 class="text-[17px] font-bold text-[#141437] dark:text-white">Contract Issues & Recommendations</h3>
          <p class="text-[13px] text-[#6b7280] dark:text-gray-400">AI-driven insights based on recent portfolio
            performance</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

        @for (card of recommendationCards(); track card.title) {
        <div class="rounded-2xl p-5 border" [ngClass]="card.themeClasses.card">
          <div class="flex justify-between items-start mb-4">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center" [ngClass]="card.themeClasses.iconWrap">
              <app-icon-v2 [name]="card.icon" size="20"></app-icon-v2>
            </div>
            <span class="px-2.5 py-1 text-xs font-medium rounded-md" [ngClass]="card.themeClasses.badge">{{
              card.severity }}</span>
          </div>
          <h4 class="text-sm font-semibold text-gray-900 dark:text-white mb-1">{{ card.title }}</h4>

          @if (card.subValue) {
          <div class="flex items-baseline gap-2 mb-2">
            <span class="text-xl font-bold" [ngClass]="card.valueColor">{{ card.value }}</span>
            <span
              class="text-[11px] font-medium px-2 py-0.5 bg-white dark:bg-surface-2 text-gray-500 dark:text-gray-400 rounded-md border border-gray-200 dark:border-gray-700">{{
              card.subValue }}</span>
          </div>
          } @else {
          <div class="text-xl font-bold mb-2" [ngClass]="card.valueColor">{{ card.value }}</div>
          }

          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 leading-relaxed">{{ card.description }}</p>
          <p class="text-[13px] text-gray-600 dark:text-gray-300"><span
              class="font-semibold text-gray-900 dark:text-white">Recommended Action:</span> {{ card.action }}</p>
        </div>
        }

      </div>
    </div>
  </div>